import RxkDialogMessage from './src/dialogMessage.vue'
import { createVNode, render } from 'vue'
import { v4 as uuidv4 } from 'uuid'
interface IOptions {
  visible: boolean
  messageContent: {
    title: string
    content: string // 也可传富文本
    cancelText?: string
    confirmText?: string
    showCancelBtn?: boolean
    showConfirmBtn?: boolean
    type: string // 类型，success 成功提示，error 异常提示，warn 警告提示
  }
  close?: Function
  confirmBtnFn?: Function
  isLoading?: boolean
  [key: string]: any
}
let mountNode: HTMLDivElement | null = null
let messageId = ''
const handleCloseMessage = (mountNode: HTMLDivElement | null) => {
  // 删除rootNode节点
  if (mountNode) {
    try {
      document?.body?.removeChild?.(mountNode)
      messageId = ''
      mountNode = null
    } catch (error) {
      mountNode = null
    }
  }
}
const RxkDialogMessageFun = (options: IOptions) => {
  messageId = options?.id || uuidv4()
  const id = messageId
  // 创建一个空的div
  mountNode = document.createElement('div')
  // 然后把转换成真实DOM的RxkDialogMessage组件插入到body里
  document.body.appendChild(mountNode)
  // 将options参数传入，并将RxkDialogMessage组件转换成虚拟DOM，并赋值给app
  const app = createVNode(RxkDialogMessage, {
    ...options,
    visible: options?.visible,
    isLoading: options?.isLoading,
    id: messageId,
    onClose: () => {
      handleCloseMessage(mountNode) // 关闭此弹窗，销毁dom节点
      options?.close?.() // 调回调
    },
    onConfirm: async function (fn: Fn) {
      if (options?.confirmBtnFn) {
        const res = await options?.confirmBtnFn?.() // 等待传进来的事件
        if (messageId === id) {
          // 判断是否关闭的是同一个弹窗(如果在等待中点击了取消按钮。再次点击打开，异步成功后，会关掉新打开的弹窗)
          fn?.() // 不管返回是true还是false，操作按钮的loading消失
          if (res) {
            handleCloseMessage(mountNode)
          }
        }
      } else {
        // 点击确定直接关闭
        if (messageId === id) {
          fn?.()
          handleCloseMessage(mountNode)
        }
      }
    }
  })
  // render函数的作用就是将RxkDialogMessage组件的虚拟DOM转换成真实DOM并插入到mountNode元素里
  render(app, mountNode)
}
// 注册全局组件
RxkDialogMessageFun.install = (app: any) => {
  app.config.globalProperties.$RxkDialogMessageFun = (options: any) => RxkDialogMessageFun(options)
}
export { RxkDialogMessage, RxkDialogMessageFun }
